const PACES = [
  ["chatty", "chatty pace"],
  ["steady", "steady"],
  ["quick", "quick-ish"],
  ["coffee", "here for the post-run coffee"],
];

export const PaceChips = ({ value, onChange }) => (
  <>
    <label id="plabel">your pace</label>
    <div className="chips" role="radiogroup" aria-labelledby="plabel">
      {PACES.map(([v, text]) => (
        <label className="chip" key={v}>
          <input type="radio" name="pace" value={v} checked={value === v} onChange={onChange} data-testid={`pace-${v}`} />
          <span>{text}</span>
        </label>
      ))}
    </div>
  </>
);
